import { Component } from '@angular/core';

/** No real changelog data exists yet an honest empty state instead of
 *  inventing entries, so the sidebar's Changelog link (see docs-layout)
 *  doesn't dead-end. Swap the empty state for a real list once there's
 *  something to publish. */
@Component({
  selector: 'app-docs-changelog',
  standalone: false,
  templateUrl: './docs-changelog.html',
})
export class DocsChangelog {}
